import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { MetricConfig, MetricProvider } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';
import styles from './MetricDetailsTab.module.scss';

type Props = {
  metric: MetricProvider;
  config: MetricConfig;
};

export function MetricDetailsTab( { metric, config }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <section
      className={ styles.container }
      data-deprecated={ config.isDeprecated ? 'true' : undefined }
      data-testid="metric-details-tab"
    >
      <h3 className={ styles.heading }>General Properties</h3>
      <InfoCardRow>
        <InfoCard label="Metric id" value={ metric.id } />
        <InfoCard label="Created by" value={ config.createdBy ?? '—' } />
        <InfoCard label="Created" value={ formatTimestamp( config.createdAt, useLocalZone ) } />
        <InfoCard label="Last Updated" value={ formatTimestamp( config.updatedAt, useLocalZone ) } />
      </InfoCardRow>
    </section>
  );
}
